export { Signal as ClubsConnectionSignal, Signal } from '@devprotocol/elements/constants';
import { decode as decode$1, encode as encode$1 } from 'js-base64';
import { parse, stringify } from 'yaml';
import { arrayify, addresses, clientsSTokens as clientsSTokens$1, client } from '@devprotocol/dev-kit';
import { keccak256, parseUnits, ZeroAddress, AbiCoder, hashMessage, recoverAddress, formatUnits, WeiPerEther, isAddress, MaxUint256 } from 'ethers';
import { tryCatch, always, xprod, mergeDeepRight, equals } from 'ramda';
import { positionsCreateWithEth, positionsCreateWithEthForPolygon, clientsSTokens, positionsCreateWithAnyTokens, clientsProperty } from '@devprotocol/dev-kit/agent';
import { whenDefined, whenDefinedAll, whenNotError, whenNotErrorAll, isNotError } from '@devprotocol/util-ts';
import BigNumber from 'bignumber.js';
import hashi from '@devprotocol/hashi/tailwind';
import { hsExtendedColorTokens } from '@devprotocol/hashi/tailwind/extensions';
import containerQueries from '@tailwindcss/container-queries';
import axios from 'axios';
import pQueue from 'p-queue';
import { marked } from 'marked';
import DOMPurify from 'isomorphic-dompurify';

const astro = function (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
options) {
    return {
        name: '@devprotocol/clubs-core',
        hooks: {
            'astro:config:setup': async ({ updateConfig }) => {
                // eslint-disable-next-line functional/no-expression-statements
                updateConfig({
                    vite: {
                        ssr: {
                            noExternal: [/^.*clubs-plugin.*$/],
                        },
                        optimizeDeps: {
                            include: [
                                '@coinbase/wallet-sdk',
                                '@solana/buffer-layout',
                                '@stablelib/chacha20poly1305',
                                '@stablelib/ed25519',
                                '@stablelib/hkdf',
                                '@stablelib/random',
                                '@stablelib/sha256',
                                '@stablelib/x25519',
                                '@walletconnect/environment',
                                '@walletconnect/heartbeat',
                                '@walletconnect/jsonrpc-utils',
                                '@walletconnect/logger',
                                '@walletconnect/time',
                                '@walletconnect/window-getters',
                                '@walletconnect/window-metadata',
                                'bigint-buffer',
                                'bn.js',
                                'borsh',
                                'bs58',
                                'buffer',
                                'buffer/index.js',
                                'country-list',
                                'eventemitter3',
                                'events',
                                'hoist-non-react-statics',
                                'isomorphic-dompurify',
                                'isomorphic-unfetch',
                                'jayson',
                                'jayson/lib/client/browser',
                                'lodash',
                                'lodash.isequal',
                                'lodash/camelCase',
                                'lodash/has',
                                'lodash/mapKeys',
                                'lodash/mapValues',
                                'lodash/snakeCase',
                                'prop-types',
                                'property-expr',
                                'qrcode',
                                'query-string',
                                'react-fast-compare',
                                'toposort',
                                'void-elements',
                            ],
                        },
                    },
                });
            },
        },
    };
};

/* eslint-disable functional/no-mixed-types */
var ClubsSlotName;
(function (ClubsSlotName) {
    ClubsSlotName["AdminBodyBeforeContents"] = "admin:body:before-contents";
    ClubsSlotName["AdminBodyAfterContents"] = "admin:body:after-contents";
    ClubsSlotName["AdminSidebarBeforeTitle"] = "admin:sidebar:before-title";
    ClubsSlotName["AdminAsideAfterBuiltInButtons"] = "admin:aside:after-built-in-buttons";
    ClubsSlotName["AdminModalCcontent"] = "admin:modal:content";
    ClubsSlotName["AdminSidebarBeforeOverviewLink"] = "admin:sidebar:before-overview-link";
    ClubsSlotName["AdminSidebarBeforeThemeLink"] = "admin:sidebar:before-theme-link";
    ClubsSlotName["AdminSidebarAfterBuiltInPrimaryLinks"] = "admin:sidebar:after-built-in-primary-links";
    ClubsSlotName["AdminSidebarBeforeFooter"] = "admin:sidebar:before-footer";
    ClubsSlotName["AdminSidebarAfterFooter"] = "admin:sidebar:after-footer";
    ClubsSlotName["PageContentHomeBeforeContent"] = "page:content:home:before-content";
    ClubsSlotName["PageContentHomeAfterContent"] = "page:content:home:after-content";
    ClubsSlotName["PageContentAnywhereBeforeContent"] = "page:content:anywhere:before-content";
    ClubsSlotName["PageContentAnywhereAfterContent"] = "page:content:anywhere:after-content";
    ClubsSlotName["ConnectButton"] = "clubs:connect-button";
})(ClubsSlotName || (ClubsSlotName = {}));
var ClubsPluginCategory;
(function (ClubsPluginCategory) {
    ClubsPluginCategory["Monetization"] = "monetization";
    ClubsPluginCategory["Growth"] = "growth";
    ClubsPluginCategory["Governance"] = "governance";
    ClubsPluginCategory["Uncategorized"] = "uncategorized";
    ClubsPluginCategory["Theme"] = "theme";
})(ClubsPluginCategory || (ClubsPluginCategory = {}));
var ClubsPluginSignal;
(function (ClubsPluginSignal) {
    ClubsPluginSignal["DisplayWideWidth"] = "display:wide-width";
    ClubsPluginSignal["DisplayFullWidth"] = "display:full-width";
    ClubsPluginSignal["DisplayFullPage"] = "display:full-page";
})(ClubsPluginSignal || (ClubsPluginSignal = {}));
var ClubsPreferredColorScheme;
(function (ClubsPreferredColorScheme) {
    ClubsPreferredColorScheme["System"] = "system";
    ClubsPreferredColorScheme["Light"] = "light";
    ClubsPreferredColorScheme["Dark"] = "dark";
})(ClubsPreferredColorScheme || (ClubsPreferredColorScheme = {}));
var ClubsEvents;
(function (ClubsEvents) {
    ClubsEvents["UpdatePluginOptions"] = "clubs:update_plugin_options";
    ClubsEvents["UpdatedPluginOptions"] = "clubs:updated_plugin_options";
    ClubsEvents["UpdateConfiguration"] = "clubs:update_configuration";
    ClubsEvents["UpdatedConfiguration"] = "clubs:updated_configuration";
    ClubsEvents["BuildConfiguration"] = "clubs:build_configuration";
    ClubsEvents["SubmitConfiguration"] = "clubs:submit_configuration";
    ClubsEvents["FinishConfiguration"] = "clubs:submit_finish_configuration";
    ClubsEvents["ControlModal"] = "clubs:control_modal";
    ClubsEvents["UpdatePreferredColorScheme"] = "clubs:updated_preferred_color_scheme";
})(ClubsEvents || (ClubsEvents = {}));

const decode = (value) => parse(decode$1(value), (key, value) => {
    return typeof value === 'bigint' && value <= Number.MAX_SAFE_INTEGER
        ? Number(value)
        : value;
}, {
    version: '1.2',
    customTags: ['binary', 'timestamp'],
    intAsBigInt: true,
});

const encode = (value) => encode$1(stringify(value, {
    version: '1.2',
    customTags: ['binary', 'timestamp'],
    intAsBigInt: true,
}));

const bytes32Hex = (payload) => {
    const v = typeof payload === 'string'
        ? /^[0-9][0-9,]*[0-9]$/.test(payload)
            ? new Uint8Array(payload.split(',').map(Number))
            : tryCatch((str) => new Uint8Array(arrayify(JSON.parse(str))), always(payload))(payload)
        : payload instanceof Uint8Array
            ? payload
            : new Uint8Array(arrayify(payload));
    return typeof v === 'string' ? v : keccak256(v);
};

const getClubsConfig = async (fetcher) => {
    const config = await fetcher();
    const encoded = typeof config === 'string' ? config : encode(config);
    const decoded = typeof config === 'string' ? decode(config) : config;
    return [decoded, encoded];
};

/**
 * Converts RegExp to a special symbol string
 * @param reg RegExp
 * @returns symbol string
 *
 * @example
 * ```ts
 * regexpToSymbol(/.+/) // "[[.+]]"
 * ```
 */
const regexpToSymbol = (reg) => `[[${reg.toString().slice(1, -1)}]]`;
/**
 * Converts special symbol string to RegExp
 * @param str special symbol string
 * @returns parced RegExp or string
 *
 * @example
 * ```ts
 * symbolToRegexp("a") // "a"
 * symbolToRegexp("[[.+]]") // new RegExp(".+")
 * ```
 */
const symbolToRegexp = (str) => {
    const isRegExp = str.startsWith('[[') && str.endsWith(']]');
    return isRegExp ? new RegExp(str.slice(2, -2)) : str;
};

var CurrencyOption;
(function (CurrencyOption) {
    CurrencyOption["DEV"] = "dev";
    CurrencyOption["ETH"] = "eth";
    CurrencyOption["USDC"] = "usdc";
    CurrencyOption["MATIC"] = "matic";
})(CurrencyOption || (CurrencyOption = {}));

const stakeWithEth = async ({ provider, propertyAddress, devAmount, ethAmount, payload, gatewayAddress, gatewayBasisPoints, }) => {
    const { estimatedEth, estimatedDev, create } = await positionsCreateWithEth({
        provider,
        devAmount: whenDefined(devAmount, (dev) => parseUnits(dev, 18).toString()),
        ethAmount: whenDefined(ethAmount, (eth) => parseUnits(eth, 18).toString()),
        destination: propertyAddress,
        payload,
        gatewayAddress,
        gatewayBasisPoints,
    });
    return { estimatedEth, estimatedDev, create };
};
const stakeWithEthForPolygon = async ({ provider, propertyAddress, devAmount, ethAmount, payload, from, gatewayAddress, gatewayBasisPoints, } // For example 10000 is 100%
) => {
    const { estimatedEth, estimatedDev, create } = await positionsCreateWithEthForPolygon({
        provider,
        devAmount: whenDefined(devAmount, (dev) => parseUnits(dev, 18).toString()),
        ethAmount: whenDefined(ethAmount, (eth) => parseUnits(eth, 18).toString()),
        destination: propertyAddress,
        payload,
        gatewayAddress,
        gatewayBasisPoints,
        from,
    });
    return { estimatedEth, estimatedDev, create };
};
const tokenURISim = async (prov, propertyAddress, amount, payload, owner) => {
    const [l1, l2] = await clientsSTokens(prov);
    return (l1 || l2)?.tokenURISim({
        positions: {
            amount: whenDefined(amount, (x) => parseUnits(x.toString(), 18).toString()),
            property: propertyAddress,
        },
        payload,
        owner,
    });
};
const getTokenAddress = (currency, chain) => {
    const CURRENCY = currency.toUpperCase();
    return CURRENCY === CurrencyOption.USDC.toUpperCase() && chain === 137
        ? '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174'
        : CURRENCY === CurrencyOption.USDC.toUpperCase() && chain === 80001
            ? '0xFEca406dA9727A25E71e732F9961F680059eF1F9'
            : CURRENCY === CurrencyOption.ETH.toUpperCase() && chain === 137
                ? '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619'
                : CURRENCY === CurrencyOption.ETH.toUpperCase() && chain === 80001
                    ? '0x3c8d6A6420C922c88577352983aFFdf7b0F977cA'
                    : CURRENCY === CurrencyOption.MATIC.toUpperCase() && chain === 137
                        ? '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270'
                        : CURRENCY === CurrencyOption.MATIC.toUpperCase() && chain === 80001
                            ? '0x9c3c9283d3e44854697cd22d3faa240cfb032889'
                            : CURRENCY === CurrencyOption.DEV.toUpperCase() && chain === 137
                                ? addresses.polygon.mainnet.token
                                : CURRENCY === CurrencyOption.DEV.toUpperCase() && chain === 80001
                                    ? addresses.polygon.mumbai.token
                                    : undefined;
};
const stakeWithAnyTokens = async ({ provider, propertyAddress, tokenAmount, payload, from, gatewayAddress, gatewayBasisPoints, mintTo, currency, chain, } // For example 10000 is 100%
) => {
    const path = currency === CurrencyOption.USDC && chain === 137
        ? [
            getTokenAddress(currency, chain), // USDC
            500n,
            '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', // WETH
            10000n,
            '0xA5577D1cec2583058A6Bd6d5DEAC44797c205701', // DEV
        ]
        : currency === CurrencyOption.USDC && chain === 80001
            ? [
                getTokenAddress(currency, chain), // USDC
                10000n,
                '0x3c8d6A6420C922c88577352983aFFdf7b0F977cA', // devWETH
                10000n,
                '0xcbc698ed514dF6e54932a22515d6D0C27E4DA091', // DEV
            ]
            : currency === CurrencyOption.ETH && chain === 137
                ? [
                    getTokenAddress(currency, chain), // WETH
                    10000n,
                    '0xA5577D1cec2583058A6Bd6d5DEAC44797c205701', // DEV
                ]
                : currency === CurrencyOption.ETH && chain === 80001
                    ? [
                        getTokenAddress(currency, chain), // devWETH
                        10000n,
                        '0xcbc698ed514dF6e54932a22515d6D0C27E4DA091', // DEV
                    ]
                    : currency === CurrencyOption.MATIC && chain === 137
                        ? [
                            getTokenAddress(currency, chain), // WMATIC
                            3000n,
                            '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', // WETH
                            10000n,
                            '0xA5577D1cec2583058A6Bd6d5DEAC44797c205701', // DEV
                        ]
                        : currency === CurrencyOption.MATIC && chain === 80001
                            ? [
                                getTokenAddress(currency, chain), // WMATIC
                                3000n,
                                '0xFEca406dA9727A25E71e732F9961F680059eF1F9', // USDC
                                10000n,
                                '0x3c8d6A6420C922c88577352983aFFdf7b0F977cA', // devWETH
                                10000n,
                                '0xcbc698ed514dF6e54932a22515d6D0C27E4DA091', // DEV
                            ]
                            : undefined;
    const token = currency === CurrencyOption.MATIC ? undefined : path?.[0] ?? ZeroAddress;
    const tokenDecimals = currency === CurrencyOption.USDC ? 6 : 18;
    return positionsCreateWithAnyTokens({
        mintTo: mintTo ?? from ?? ZeroAddress,
        token,
        path,
        provider,
        tokenAmount: whenDefined(tokenAmount, (token) => parseUnits(token, tokenDecimals).toString()),
        destination: propertyAddress,
        payload,
        gatewayAddress,
        gatewayBasisPoints,
        from,
    });
};
const mintedIdByLogs = async function (logs, matcher) {
    const logMinted = logs.find((log) => log.topics.includes('0xd46616b47888bf162137201f2b51769d5891ea9b59978dc022f447f3335e4b36' // Minted,
    ));
    const [id] = whenDefined(logMinted, ({ data }) => AbiCoder.defaultAbiCoder().decode(['uint256', 'address', 'address', 'uint256', 'uint256'], data)) ?? [];
    const matchFilter = await whenDefinedAll([id, matcher], async ([_id, filt]) => {
        const tokenId = Number(_id);
        const [owner, payload] = await Promise.all([
            filt.sTokensManager.ownerOf(tokenId),
            filt.sTokensManager.payloadOf(tokenId),
        ]);
        return owner === filt.receipent && payload === bytes32Hex(filt.payload);
    });
    return matchFilter === true ? id : matchFilter === false ? undefined : id;
};

const validImageUri = (path) => {
    const src = path.startsWith('ipfs://')
        ? path.replace(/^ipfs:\/\/(.*)/, 'https://$1.ipfs.nftstorage.link/')
        : path;
    return src;
};
const fetchSTokens = async (opts) => {
    const res = await tokenURISim(opts.provider, opts.tokenAddress, opts.amount, opts.payload, opts.owner);
    const image = res ? validImageUri(res.image) : undefined;
    return { ...res, image };
};
const fetchDevForEth = async (opts) => {
    const params = {
        provider: opts.provider,
        propertyAddress: opts.tokenAddress,
        ethAmount: new BigNumber(opts.amount).toFixed(),
    };
    const { estimatedDev } = opts.chain === 137 || opts.chain === 80001
        ? await stakeWithEthForPolygon(params)
        : await stakeWithEth(params);
    return estimatedDev;
};

const reg = /(\[\[((?!\]\]).)*\]\])/gi;
const EMPTY = '';
/**
 * Returns a function that searches an array for items that have the string as value of the given key and returns it.
 * @param search URL pathname to match
 * @returns Finder function
 *
 * @example
 * ```ts
 * const router = routerFactory([{path: 'my/123', as: 1}], (i) => i.path)
 * router("my/123") // {path: 'my/123', as: 1}
 * ```
 */
const routerFactory = (list, key) => (search) => {
    return (list.find((item) => (key(item) ?? EMPTY) === (search ?? EMPTY)) ??
        list.find((item) => {
            const value = `${key(item) ?? EMPTY}`;
            const match = value.match(reg) ?? undefined;
            const regStr = match?.reduce((p, c) => {
                const regexp = symbolToRegexp(c).toString().slice(1, -1);
                return p.replace(c, `${regexp}`);
            }, value);
            const tester = whenDefined(regStr, (exp) => new RegExp(`^${exp}$`));
            return whenDefined(search, (_search) => tester?.test(_search)) ?? false;
        }));
};

/* eslint-disable functional/no-expression-statements */
const themes = [
    ClubsPreferredColorScheme.System,
    ClubsPreferredColorScheme.Light,
    ClubsPreferredColorScheme.Dark,
];
/**
 * Normalize the preferred color scheme
 * @param input - preferred color scheme input
 * @returns preferred color scheme
 */
const normalizePreferredColorScheme = (input) => {
    return themes.find((t) => t === input) ?? ClubsPreferredColorScheme.System;
};
/**
 * Get the preferred color scheme from the localStorage
 * @returns preferred color scheme
 */
const getPreferredColorScheme = () => {
    return ((_cookie) => {
        const theme = _cookie
            .split(';')
            .find((c) => c.includes('theme='))
            ?.split('=')[1];
        return normalizePreferredColorScheme(theme);
    })(document.cookie);
};
/**
 * Set the preferred color scheme to the localStorage
 * @param theme - preferred color scheme
 * @returns true or an error
 */
const setPreferredColorScheme = (theme) => {
    // eslint-disable-next-line functional/immutable-data
    document.cookie = `theme=${theme}; max-age=31536000; path=/; secure; samesite=strict`;
    document.body.dispatchEvent(new CustomEvent(ClubsEvents.UpdatePreferredColorScheme, {
        detail: { theme },
        cancelable: true,
    }));
    return true;
};

const _listPlugins = async (config, list) => {
    // Test this `reduce`: `[{a:1}, {a: 2}, {a:3}].reduce((ac, v, i)=>([...ac, {...v, i}]), [])`
    const plugins = config.plugins.reduce((ac, { id, enable = true, options = [] }, i) => {
        const fn = list.find(({ meta: _pluginMeta }) => id === _pluginMeta.id);
        return fn ? [...ac, { id, enable, options, ...fn, pluginIndex: i }] : ac;
    }, []);
    return plugins;
};
const _findCurrentTheme = (plugins) => {
    return plugins.find((plugin) => (plugin.enable === true || typeof plugin.enable === 'undefined') &&
        plugin.meta.category === ClubsPluginCategory.Theme &&
        Object.prototype.hasOwnProperty.call(plugin, 'getLayout') &&
        Object.prototype.hasOwnProperty.call(plugin.meta, 'theme'));
};
const _configFactory = (configFetcher) => async () => {
    const [config] = await getClubsConfig(configFetcher);
    return config;
};
const getPluginConfigByIdFactory = (config, plugins) => (id) => {
    const plugin = plugins.find(({ meta }) => meta.id === id);
    const res = plugin
        ? [
            {
                id: plugin.id,
                options: plugin.options,
                enable: plugin.enable,
            },
            plugin.pluginIndex,
        ]
        : [undefined, undefined];
    return res;
};
const _staticPathsFromPlugins = (config, caller, additionalProps) => async (plugins) => (await Promise.all(plugins.map(async (plugin) => {
    const plgFn = caller === 'getPagePaths'
        ? plugin.getPagePaths
        : caller === 'getAdminPaths'
            ? plugin.getAdminPaths
            : undefined;
    const results = (plgFn
        ? await plgFn(plugin.options, config, {
            getPluginConfigById: getPluginConfigByIdFactory(config, plugins),
        })
        : []).map((x) => ({ ...x, details: plugin }));
    const updated = additionalProps
        ? results.map((res, i) => ({
            ...res,
            props: { ...res.props, ...additionalProps(plugin.pluginIndex) },
        }))
        : results;
    return updated;
}))).flat();
const _sort = (a, b) => {
    return (a.order ?? Infinity) - (b.order ?? Infinity);
};
const _slotsFromPlugins = (config, factory) => async (plugins, paths, additionalProps) => {
    const results = await Promise.all(plugins.map(async (plugin) => {
        const results = plugin.getSlots
            ? await plugin.getSlots(plugin.options, config, {
                getPluginConfigById: getPluginConfigByIdFactory(config, plugins),
                paths,
                factory,
            })
            : [];
        return results;
    }));
    const propsInjected = results.flat().map((slot) => ({
        ...slot,
        props: { ...slot.props, ...additionalProps },
    }));
    const res = [...propsInjected].sort(_sort);
    return res;
};
const _pathsToPage = (paths) => paths.map((p) => (p instanceof RegExp ? regexpToSymbol(p) : p)).join('/') ||
    undefined;
const _compose = (pluginResults) => pluginResults.map((res) => ({
    params: {
        page: _pathsToPage(res.paths),
    },
    props: {
        ...res.props,
        component: res.component,
        layout: res.layout,
    },
}));
const _staticPagePathsFactory = (configFetcher, pluginsMap) => async () => {
    const [config] = await getClubsConfig(configFetcher);
    const plugins = await _listPlugins(config, pluginsMap);
    const getResultsOfPlugins = _staticPathsFromPlugins(config, 'getPagePaths');
    const pluginResults = await getResultsOfPlugins(plugins);
    const theme = _findCurrentTheme(plugins);
    const defaultLayout = await theme.getLayout(theme.options, config, {
        getPluginConfigById: getPluginConfigByIdFactory(config, plugins),
    });
    const themeInjected = pluginResults.map((res) => ({
        ...res,
        layout: res.layout ?? defaultLayout.layout,
        props: { ...res.props, ...defaultLayout.props },
    }));
    const getResultsOfGetSlots = _slotsFromPlugins(config, 'page');
    const slotsInjected = await Promise.all(themeInjected.map(async (res) => ({
        ...res,
        props: {
            ...res.props,
            clubs: {
                slots: await getResultsOfGetSlots(plugins, res.paths),
            },
        },
    })));
    const staticPaths = _compose(slotsInjected);
    return staticPaths;
};
const _staticAdminPathsFactory = (configFetcher, pluginsMap) => async () => {
    const [config, encodedClubsConfiguration] = await getClubsConfig(configFetcher);
    const plugins = await _listPlugins(config, pluginsMap);
    const getResultsOfPlugins = _staticPathsFromPlugins(config, 'getAdminPaths', (currentPluginIndex) => ({
        clubs: {
            encodedClubsConfiguration,
            currentPluginIndex,
        },
    }));
    const pluginResults = (await getResultsOfPlugins(plugins));
    const pluginsWithPaths = pluginResults.map((result) => {
        const { details: { getPagePaths, getAdminPaths, ...plg }, } = result;
        const page = _pathsToPage(result.paths);
        return {
            ...plg,
            paths: result.paths,
            pathname: page ? `/admin/${page}` : `/admin`,
            page,
        };
    });
    const injected = pluginResults.map((plg) => ({
        ...plg,
        props: {
            ...plg.props,
            clubs: {
                ...plg.props.clubs,
                plugins: pluginsWithPaths,
            },
        },
    }));
    const getResultsOfGetSlots = _slotsFromPlugins(config, 'admin');
    const slotsInjected = await Promise.all(injected.map(async (res) => ({
        ...res,
        props: {
            ...res.props,
            clubs: {
                ...res.props.clubs,
                slots: await getResultsOfGetSlots(plugins, res.paths, {
                    clubs: res.props.clubs,
                }),
            },
        },
    })));
    const staticPaths = _compose(slotsInjected);
    return staticPaths;
};
const pageFactory = (options) => {
    const getStaticPaths = _staticPagePathsFactory(options.config, options.plugins);
    const getCurrentConfig = _configFactory(options.config);
    return { getStaticPaths, getCurrentConfig };
};
const adminFactory = (options) => {
    const getStaticPaths = _staticAdminPathsFactory(options.config, options.plugins);
    const getCurrentConfig = _configFactory(options.config);
    return { getStaticPaths, getCurrentConfig };
};
const apiFactory = (options) => {
    const ALL = async (context) => {
        const [config] = await getClubsConfig(options.config);
        const plugins = await _listPlugins(config, options.plugins);
        const getPluginConfigById = getPluginConfigByIdFactory(config, plugins);
        const utils = { getPluginConfigById };
        const { path } = context.params;
        const [firstPath] = path?.split('/') ?? [];
        const plugin = plugins.find((plg) => firstPath === plg.meta.id);
        const apiRoutes = plugin && typeof plugin.getApiPaths === 'function'
            ? (await plugin.getApiPaths(plugin.options, config, utils)).filter(({ method }) => method === context.request.method)
            : [];
        const router = routerFactory(apiRoutes, (i) => _pathsToPage([plugin?.meta.id, ...i.paths]));
        const routerWithSlash = routerFactory(apiRoutes, (i) => `${_pathsToPage([plugin?.meta.id, ...i.paths])}/`);
        const apiRoute = router(path) ?? routerWithSlash(path);
        const response = apiRoute
            ? apiRoute.handler(context)
            : new Response(null, { status: 404 });
        return response;
    };
    return { ALL };
};

/* eslint-disable functional/no-expression-statements */
const setOptions = (data, pluginIndex) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.UpdatePluginOptions, {
        detail: { data, pluginIndex },
        cancelable: true,
    }));
};
const updatedOptions = (results) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.UpdatedPluginOptions, {
        detail: results,
        cancelable: true,
    }));
};
const setConfig = (data) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.UpdateConfiguration, {
        detail: { data },
        cancelable: true,
    }));
};
const updatedConfig = (results) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.UpdatedConfiguration, {
        detail: results,
        cancelable: true,
    }));
};
const buildConfig = () => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.BuildConfiguration, {
        cancelable: true,
    }));
};
const submitConfig = (data) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.SubmitConfiguration, {
        detail: { data },
        cancelable: true,
    }));
};
const finish = (results) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.FinishConfiguration, {
        detail: results,
        cancelable: true,
    }));
};
const onSubmitConfig = (handler, options) => document.body.addEventListener(ClubsEvents.SubmitConfiguration, (ev) => handler(ev.detail.data, finish), options);
const onUpdatedConfiguration = (handler, options) => document.body.addEventListener(ClubsEvents.UpdatedConfiguration, (ev) => handler(ev), options);
const onFinishConfig = (handler, options) => document.body.addEventListener(ClubsEvents.FinishConfiguration, (ev) => handler(ev), options);
const controlModal = (data) => {
    return document.body.dispatchEvent(new CustomEvent(ClubsEvents.ControlModal, {
        detail: data,
        cancelable: true,
    }));
};
const handlerStore = new WeakSet();
const onMountClient = (_handler, options) => {
    handlerStore.add(_handler);
    const handler = (data) => {
        if ((data?.target ?? document).readyState === 'complete') {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            handlerStore.has(_handler) && _handler(data);
            handlerStore.delete(_handler);
            document.removeEventListener('readystatechange', handler);
            return;
        }
    };
    document.addEventListener('readystatechange', handler, options);
    handler();
};

const toBytes = (value) => {
    return value instanceof Array
        ? Uint8Array.from(value)
        : Uint8Array.from(Object.values(value));
};

const authenticate = async ({ message, signature, previousConfiguration, provider, }) => {
    const digest = hashMessage(message);
    const address = recoverAddress(digest, signature);
    const previousConfig = decode(previousConfiguration);
    const propertyClient = await clientsProperty(provider, previousConfig.propertyAddress);
    if (!propertyClient || propertyClient.length <= 0) {
        return false;
    }
    const property = propertyClient[0] ?? propertyClient[1];
    const totalSupply = BigInt((await property?.totalSupply()) ?? 0);
    const userBalance = BigInt((await property?.balanceOf(address)) ?? 0);
    const userShare = Number(
    // Parsing (balance * 1e18 / supply) with 1e16
    formatUnits((userBalance * WeiPerEther) / totalSupply, 16));
    return userShare >= previousConfig.adminRolePoints;
};
const isAdmin = async ({ address, previousConfiguration, provider, }) => {
    const propertyClient = await clientsProperty(provider, previousConfiguration.propertyAddress);
    if (!propertyClient || propertyClient.length <= 0) {
        return false;
    }
    const property = propertyClient[0] ?? propertyClient[1];
    const totalSupply = BigInt((await property?.totalSupply()) ?? 0);
    const userBalance = BigInt((await property?.balanceOf(address)) ?? 0);
    const userShare = Number(
    // Parsing (balance * 1e18 / supply) with 1e16
    formatUnits((userBalance * WeiPerEther) / totalSupply, 16));
    return userShare >= previousConfiguration.adminRolePoints;
};

const clubs = {
    content: [
        './{src,node_modules/@devprotocol/clubs-core,node_modules/**/*clubs*plugin*}/**/*.{astro,svelte,vue,html,js,jsx,ts,tsx}',
    ],
    theme: {
        extend: {
            colors: {
                ...hashi.theme.colors,
                ...hsExtendedColorTokens,
            },
            fontFamily: hashi.theme.fontFamily,
        },
    },
    plugins: [containerQueries],
};

/**
 * Fetches the profile of the user
 *
 * @param {string} address - The wallet adddress of the user
 *
 * @example
 *
 * ```ts
 * import { fetchProfile } from '@devprotocol/clubs-core'
 *
 * const { profile, error } = await fetchProfile('0x...')
 * ```
 */
const fetchProfile = async (address) => {
    return !isAddress(address)
        ? {
            profile: undefined,
            error: new Error('Invalid address'),
        }
        : (async () => {
            const apiEndpoint = `https://clubs.place/api/profile/${address}`;
            const res = await fetch(apiEndpoint);
            return res.ok
                ? (async () => {
                    const profile = (await res.json());
                    return {
                        profile,
                        error: undefined,
                    };
                })()
                : {
                    profile: undefined,
                    error: new Error(`Error fetching profile at ${apiEndpoint}`),
                };
        })();
};

const has = (base, lang) => Object.hasOwn(base, lang);
const i18nFactory = (parts) => (langs) => (key, vars) => {
    const base = parts[key];
    const cand = langs.find((lang) => has(base, lang));
    const content = cand ? base[cand] : base[Object.keys(base)[0]];
    return typeof content === 'function' ? content(vars ?? []) : content;
};

const ProseTextInheritClassNames = [
    'text-inherit',
    'prose',
    'prose-headings:text-inherit',
    'prose-p:text-inherit',
    'prose-a:text-inherit',
    'prose-blockquote:text-inherit',
    'prose-strong:text-inherit',
    'prose-li:text-inherit',
    'prose-th:text-inherit',
    'prose-td:text-inherit',
    'prose-li:list-[inherit]',
];
const ProseTextInherit = ProseTextInheritClassNames.reduce((c, p) => `${c} ${p}`);

const connectionId = 'x-club-connection';

const SinglePath = /((?![/?#]).)+/;

/**
 * Find a path where matches Astro.params.page
 * @param page Astro.params.page of [...page]
 * @param items The result array of getStaticPaths
 * @returns the found path or undefined
 *
 * @example
 * ```ts
 * findPage("my/123", [...])
 * ```
 */
const findPage = (page, items) => routerFactory(items, (i) => i.params.page)(page);

const queue = new pQueue({ concurrency: 3 });
const check = async ({ contract, pair: [mem, tokenId], account, base, }) => {
    const payload = whenDefined(mem.payload, bytes32Hex);
    const sTokenContract = contract.contract();
    const testForPayload = await whenDefined(payload, async (v) => (await queue.add(always(sTokenContract.payloadOf(tokenId)))) === v);
    const testForAccessControl = (await whenDefined(mem.accessControl?.url, async (_accessControl) => {
        const url = _accessControl.startsWith('http')
            ? new URL(_accessControl)
            : new URL(_accessControl, base);
        // eslint-disable-next-line functional/no-expression-statements
        url.searchParams.set('account', account);
        const result = await axios(url.toString()).catch((err) => err);
        const body = await whenNotError(result, (r) => r.data);
        return isNotError(body)
            ? Number(body) === 1
                ? true
                : new Error(`${url.href} returned a value other than 1.`)
            : body;
    })) ?? null;
    if (testForPayload === true &&
        (testForAccessControl === true || testForAccessControl === null)) {
        return mem;
    }
    return Promise.reject(testForAccessControl instanceof Error
        ? testForAccessControl
        : new Error('Membership not found'));
};
/**
 * Create a validator function to check the user has the available membership(s).
 * @param options - all options
 * @param options.provider - ethers ContractRunner
 * @param options.propertyAddress - the property address
 * @param options.account - the account address
 * @param options.base - the base URL if the membership has an access control URL and it is a relative URL.
 * @returns the verifier function
 * @example
 *
 * ```ts
 * import { membershipVerifierFactory } from '@devprotocol/clubs-core'
 *
 * const hasOneOf = await membershipVerifierFactory({provider, propertyAddress, account})
 * const res = await hasOneOf(memberships)
 * ```
 */
const membershipVerifierFactory = async ({ provider, propertyAddress, account, base, }) => {
    const clients = await clientsSTokens$1(provider);
    const contract = whenDefined(clients, ([l1, l2]) => l1 ?? l2) ??
        new Error('STokensManager instance cannot be created');
    const detectSTokens = whenNotError(contract, client.createDetectSTokens);
    // gets all sTokens of the passed Property address that the visitor have
    const allSTokens = await whenNotError(detectSTokens, (detector) => queue.add(always(detector(propertyAddress, account))));
    /**
     * The verifier function
     * @param memberships - the memberships to check (one of them is enough to pass the check)
     * @returns the result
     * @example
     * ```ts
     * const hasOneOf = await membershipVerifierFactory({provider, propertyAddress, account})
     * const res = await hasOneOf(memberships)
     * console.log(res)
     * // { result: true, membership: { payload: '0x...', accessControl: { url: 'http://...' } } }
     * ```
     */
    return async (memberships) => {
        // https://ramdajs.com/docs/#xprod
        const pairs = whenNotError(allSTokens, (list) => xprod(memberships, list ?? []));
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/any
        const checkResult = await whenNotErrorAll([contract, pairs], ([STokens, _pairs]) => _pairs.length > 0
            ? Promise.any(_pairs.map(async (pair) => check({ pair, base, contract: STokens, account }))).catch((err) => new Error('Membership not found', { cause: err }))
            : memberships.length === 0
                ? undefined
                : new Error(`account:${account} does not have any memberships.`));
        const result = isNotError(checkResult)
            ? {
                membership: checkResult,
                result: true,
            }
            : {
                error: checkResult,
                result: false,
            };
        // returns the result
        return result;
    };
};
/**
 * Convert the membership object to the struct object.
 * The struct object is used in the `ERC20SimpleCollections.sol` contract.
 * https://github.com/dev-protocol/dynamic-s-tokens-simple-collections/blob/main/contracts/ERC20SimpleCollections.sol
 * @param mem membership object
 * @param chain chain id
 * @returns
 */
const membershipToStruct = (mem, chain) => {
    const hasNoPrice = mem.price === undefined;
    const decimals = whenDefined(mem.currency, (currency) => currency.toLowerCase() === CurrencyOption.USDC ? 6 : 18);
    const useNativeToken = whenDefined(mem.currency, (currency) => {
        const _currency = currency.toLowerCase();
        return ((chain === 137 && _currency === CurrencyOption.MATIC) ||
            (chain === 80001 && _currency === CurrencyOption.MATIC) ||
            (chain === 1 && _currency === CurrencyOption.ETH));
    });
    const token = useNativeToken
        ? ZeroAddress
        : whenDefined(mem.currency, (currency) => getTokenAddress(currency, chain));
    return {
        src: mem.imageSrc,
        name: JSON.stringify(mem.name).slice(1, -1),
        description: JSON.stringify(mem.description).slice(1, -1),
        requiredTokenAmount: whenDefinedAll([mem.price, decimals], ([price, dp]) => parseUnits(new BigNumber(price).dp(dp, 1).toFixed(), dp)) ?? MaxUint256,
        requiredTokenFee: hasNoPrice
            ? MaxUint256
            : mem.fee?.percentage && decimals
                ? parseUnits(new BigNumber(mem.price)
                    .times(mem.fee.percentage)
                    .dp(decimals, 1)
                    .toFixed(), decimals)
                : 0n,
        gateway: hasNoPrice ? ZeroAddress : mem.fee?.beneficiary ?? ZeroAddress,
        token: token ?? ZeroAddress,
    };
};
/**
 * Find offerings by some options.
 * @param config ClubsConfigration
 * @param search all find options
 * @returns an array of filtered offerings
 */
const findOfferings = (config, search) => {
    const filtered = (config.offerings ?? []).filter((item) => {
        const base = { ...item, payload: bytes32Hex(item.payload) };
        const match = search.payload
            ? { ...search, payload: bytes32Hex(search.payload) }
            : search;
        const merged = mergeDeepRight(base, match);
        return equals(base, merged);
    });
    return filtered;
};

// https://github.com/cure53/DOMPurify/blob/main/src/tags.js
const tags = [
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'shadow',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
];
// https://github.com/cure53/DOMPurify/blob/main/src/attrs.js
const attrs = [
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
    'slot',
];

const renderer = {
    link(href, _, text) {
        const url = new URL(href);
        const youtube = url.host === 'youtube.com' ||
            url.host === 'www.youtube.com' ||
            url.host === 'youtu.be';
        const v = url.host === 'youtu.be'
            ? url.pathname.replace('/', '')
            : url.searchParams.get('v');
        return youtube
            ? `<iframe class="youtube aspect-video mx-auto w-full rounded" src="https://www.youtube.com/embed/${v}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
            : `<a href="${href}">${text}</a>`;
    },
};
const parser = marked.use({ renderer });
/**
 * Parses the given markdown content and returns sanitized HTML.
 *
 * @param content The markdown content to parse.
 * @returns The sanitized HTML representation of the parsed markdown.
 */
const markdownToHtml = (content = '') => {
    return DOMPurify.sanitize(parser.parse(content), {
        ALLOWED_TAGS: [...tags, 'iframe'],
        ALLOWED_ATTR: [
            ...attrs,
            'src',
            'frameborder',
            'allow',
            'onmousewheel',
            'width',
            'height',
            'style',
        ],
    });
};

const uploadFile = async ({ file, signature, message, }) => {
    const formData = new FormData();
    formData.append('file', file);
    const params = new URLSearchParams();
    whenDefinedAll([signature, message], ([sig, msg]) => {
        params.append('signature', sig);
        params.append('message', msg);
    });
    const response = await fetch(`https://storage.clubs.place/api/blob?${params.toString()}`, {
        method: 'POST',
        body: formData,
    }).catch((err) => err);
    const result = isNotError(response)
        ? await response
            .json()
            .then((r) => r)
            .catch((err) => err)
        : response;
    return result;
};

export { ClubsEvents, ClubsPluginCategory, ClubsPluginSignal, ClubsPreferredColorScheme, ClubsSlotName, CurrencyOption, ProseTextInherit, ProseTextInheritClassNames, SinglePath, adminFactory, apiFactory, authenticate, buildConfig, bytes32Hex, connectionId, controlModal, decode, astro as default, encode, fetchDevForEth, fetchProfile, fetchSTokens, findOfferings, findPage, getPreferredColorScheme, getTokenAddress, i18nFactory, isAdmin, markdownToHtml, membershipToStruct, membershipVerifierFactory, mintedIdByLogs, normalizePreferredColorScheme, onFinishConfig, onMountClient, onSubmitConfig, onUpdatedConfiguration, pageFactory, regexpToSymbol, routerFactory, setConfig, setOptions, setPreferredColorScheme, stakeWithAnyTokens, stakeWithEth, stakeWithEthForPolygon, submitConfig, symbolToRegexp, clubs as tailwindPreset, toBytes, tokenURISim, updatedConfig, updatedOptions, uploadFile, validImageUri };
